import { createSlice } from "@reduxjs/toolkit";

export interface IAccountingReportState {
    companyId: string;
    accountId:string;
    warehouseId:string;
    startDate: Date;
    endDate: Date;
}

const initialState: IAccountingReportState = {
    companyId: "",
    accountId:"",
    warehouseId:"",
    startDate: new Date(2022,1,1),
    endDate: new Date(2023, 11,11),
}

export const accountingReportSlice = createSlice({
    name: "accountingReport",
    initialState,
    reducers: {
        setReportParameters: (state, action) => {
            state.companyId = action.payload.companyId;
            state.startDate = action.payload.startDate;
            state.accountId = action.payload.accountId;
            state.endDate = action.payload.endDate;
            state.warehouseId = action.payload.warehouseId;
        }
    }
});

export const { setReportParameters } = accountingReportSlice.actions;

export const selectCompanyId = (state: RootState) => state.accountingReport.companyId;
export const selectAccountId = (state: RootState) => state.accountingReport.accountId;
export const selectStartDate = (state: RootState) => state.accountingReport.startDate;
export const selectEndDate = (state: RootState) => state.accountingReport.endDate;

// export const selectSelectedRow = (state: RootState) => state.accountingReport.selectedRow;
export const selectWarehouseId = (state:RootState) => state.accountingReport.warehouseId

interface RootState {
    accountingReport: IAccountingReportState
}

export const accountingReport = accountingReportSlice.reducer;